import React, { useEffect, useState } from 'react';
import { getGuru } from '../composables/fetchAPI';

const ManagePortfolioPage: React.FC<{ userInfo?: any }> = ({ userInfo }) => {
  const [portfolios, setPortfolios] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPortfolios = async () => {
      setLoading(true);
      try {
        // Fetch all gurus, then find the current user's guru entry
        const gurus = await getGuru();
        const userGuru = gurus.find((g: any) => g.id === userInfo?.id);
        setPortfolios(userGuru?.portfolios || []);
      } catch {
        setPortfolios([]);
      }
      setLoading(false);
    };
    fetchPortfolios();
  }, [userInfo]);

  if (loading) return <div className="p-8">Loading...</div>;

  return (
    <div className="max-w-2xl mx-auto p-8">
      <h1 className="text-2xl font-bold mb-6">My Portfolios</h1>
      {portfolios.length === 0 ? (
        <div className="text-gray-500">No portfolios found.</div>
      ) : (
        <ul className="space-y-4">
          {portfolios.map((p: any) => (
            <li key={p.id} className="border rounded-lg p-4 bg-gray-50">
              <div className="font-bold text-lg">{p.name}</div>
              <div className="text-gray-600">{p.description}</div>
              <div className="text-xs text-gray-400 mt-2">Portfolio ID: {p.id}</div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ManagePortfolioPage;